import {TextField, Typography} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import { AddressAction } from '../../../action/address.action';
import { AddressActor } from '../../../actor/address.actor';
import { SubDistrict } from '../../../service/response/sub-district.response';
import { AddressStore } from '../../../store/address.store';
import { useObservable } from '../../../useSubscriber';
import {useStyles} from './ui.style';
import { DelarStore } from "../../../store/delar.store"
import { useTranslation } from "react-i18next"
export const SubDistrictPickerComponent = (props: any) => {

    const [subDistrictList, subDistrictListError] = useObservable(AddressStore.getSubDistrictList(), AddressStore.getSubDistrictListObservable())
    const [delarDtoError, dtoee] = useObservable(DelarStore.getDelarDtoError(), DelarStore.getDelarDtoErrorObservable())
    const { t } = useTranslation();
    const [subDistrictData, setSubDistrictData] = useState<Array<SubDistrict>>([])
    const classes = useStyles();
    useEffect(() => {
        AddressActor({ "type": AddressAction.GET_SUB_DISTRICT_LIST }, {"districtCode": props.districtCode})
    }, [])

    useEffect(() => {
        if (!subDistrictListError.error && subDistrictList) {
            var newSubDistricts: Array<SubDistrict> = Object.keys(subDistrictList).map(function(index: any){
                let subDistrict = (subDistrictList as SubDistrict[])[index]
                return subDistrict;
            });
            setSubDistrictData(newSubDistricts)
        }
    }, [subDistrictList])

    return (
        <Autocomplete
            id="combo-box-demo"
            options={subDistrictData}
            getOptionLabel={(option: SubDistrict) => option.name}
            onChange={(event, subDistrict) => props.setSubDistrict(subDistrict)}
            fullWidth={true}
            loading={subDistrictData.length > 0 ? true : false}
            classes={{ input: classes.input  }}
            style={{marginTop:8,}}
            renderInput={(params: any) => <TextField {...params}
            classes = {{
                root: delarDtoError?.city.error?classes.TextFieldRoot: classes.noStyle,
            }}
                label={<Typography variant="body2" style ={{fontSize: 12}} color="textSecondary">{t("choose_city")}</Typography>} variant="outlined" />}
        />
    );
}